<template>
  <div :class="sectionClass">
    <p :class="fields.textColour.fields.colourSlug">
      <span v-html="fields.quote"></span> –
      <span v-html="fields.author"></span>
    </p>
  </div>
</template>

<script>
import { isMobile } from '@/helpers'

export default {
  props: ['sys', 'fields'],
  computed: {
    sectionClass() {
      return {
        'testimonial-item': true,
        'uk-text-center': true,
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
  },
}
</script>

<style lang="scss" scoped>
.sectionMobile {
  font-size: small;
}
</style>



// WEBPACK FOOTER //
// src/components/TestimonialItem.vue